var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const initBackgroundColorDetector = () => {
    var _a, _b;
    //right now the code is written to work with this specific case only: header + banner-slider-widget in HOMEPAGE
    if (document.querySelector(".homepage")) {
        let image;
        const isSliderActive = document.querySelector("[data-background-detector-container]").querySelector("[data-slide].is-selected");
        if (isSliderActive) {
            image = (_a = document.querySelector("[data-slide].is-selected")) === null || _a === void 0 ? void 0 : _a.querySelector("[data-background-detector]");
        }
        else {
            image = (_b = document.querySelector("[data-slide]")) === null || _b === void 0 ? void 0 : _b.querySelector("[data-background-detector]");
        }
        if (image) {
            returnBackgroundColor(image).then((rgb) => {
                //https://awik.io/determine-color-bright-dark-using-javascript/
                const r = rgb[0];
                const g = rgb[1];
                const b = rgb[2];
                const hsp = Math.sqrt(0.299 * (r * r) +
                    0.587 * (g * g) +
                    0.114 * (b * b));
                // Using the HSP value, determine whether the color is light or dark
                if (hsp > 127.5) {
                    //light
                    header.classList.remove("dark-bg");
                    header.classList.add("light-bg");
                }
                else {
                    //dark
                    header.classList.remove("light-bg");
                    header.classList.add("dark-bg");
                }
            });
        }
    }
};
const returnBackgroundColor = (image) => __awaiter(this, void 0, void 0, function* () {
    /* https://stackoverflow.com/questions/2541481/get-average-color-of-image-via-javascript */
    //create a promise so we can wait for the image to load
    return new Promise(resolve => {
        //create a canvas and get the context
        const context = document.createElement('canvas').getContext('2d');
        context.imageSmoothingEnabled = true;
        image.crossOrigin = "";
        //if image is already loaded
        if (image.complete) {
            //draw image on canvas, condensed in 1 pixel
            drawImage(context, image).then(result => resolve(result));
            //return a promise containing the hex string
        }
        else {
            //if not loaded, wait until it's ready
            image.onload = () => {
                drawImage(context, image).then(result => resolve(result));
            };
        }
    });
});
const drawImage = (context, img) => __awaiter(this, void 0, void 0, function* () {
    return new Promise(resolve => {
        context.drawImage(img, 0, 0, 1, 1);
        resolve(context.getImageData(0, 0, 1, 1).data.slice(0, 3));
    });
});
